import { render, staticRenderFns } from "./MainMenuEntries.vue?vue&type=template&id=5fb5744a&scoped=true&"
import script from "./MainMenuEntries.vue?vue&type=script&lang=js&"
export * from "./MainMenuEntries.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuEntries.vue?vue&type=style&index=0&id=5fb5744a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb5744a",
  null
  
)

export default component.exports